import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthenticationService from "../../Api/AuthenticationService";

const SignUpLayer = () => {

  const AuthObject = new AuthenticationService();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    mobile_number: "",
    password: ""
  });

  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate full name
    if (!formData.full_name.trim()) {
      newErrors.full_name = "Full name is required";
    } else if (formData.full_name.trim().length < 3) {
      newErrors.full_name = "Full name must be at least 3 characters long";
    }

    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    // Validate mobile number
    const phoneRegex = /^\d{10}$/;
    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = "Mobile number is required";
    } else if (!phoneRegex.test(formData.mobile_number)) {
      newErrors.mobile_number = "Invalid mobile number (10 digits required)";
    }

    // Validate password
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    } else if (!passwordRegex.test(formData.password)) {
      newErrors.password = "Password must contain at least one uppercase letter, one lowercase letter, and one number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsLoading(true);
      try {
        const response = await AuthObject.signup(formData);
        const data = await response.data;

        if (response.status === 200 && data.status === "success") {
          // Navigate to OTP verification with the token
          navigate('/verify-otp', {
            state: {
              token: data.data.token,
              email: formData.email
            }
          });
        } else {
          // Handle API errors
          setErrors(prev => ({
            ...prev,
            submit: data.message || "Signup failed. Please try again."
          }));
        }
      } catch (error) {
        setErrors(prev => ({
          ...prev,
          submit: "Something went wrong. Please try again."
        }));
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
   <>
     <div>
            <Link to="/" className="mb-40 max-w-290-px">
              <img src="assets/images/logo.png" alt="" />
            </Link>
            <h4 className="mb-12">Sign Up to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! please enter your detail
            </p>
          </div>
          {errors.submit && (
            <div className="alert alert-danger mb-3" role="alert">
              {errors.submit}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="f7:person" />
              </span>
              <input
                type="text"
                className={`form-control h-56-px bg-neutral-50 radius-12 ${errors.full_name ? 'is-invalid' : ''}`}
                placeholder="Full Name"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
              />
              {errors.full_name && <div className="invalid-feedback">{errors.full_name}</div>}
            </div>

            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className={`form-control h-56-px bg-neutral-50 radius-12 ${errors.email ? 'is-invalid' : ''}`}
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>

            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="solar:phone-outline" />
              </span>
              <input
                type="tel"
                className={`form-control h-56-px bg-neutral-50 radius-12 ${errors.mobile_number ? 'is-invalid' : ''}`}
                placeholder="Mobile Number"
                name="mobile_number"
                value={formData.mobile_number}
                onChange={handleChange}
              />
              {errors.mobile_number && <div className="invalid-feedback">{errors.mobile_number}</div>}
            </div>

            <div className="mb-20">
              <div className="position-relative">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:lock-password-outline" />
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    className={`form-control h-56-px bg-neutral-50 radius-12 ${errors.password ? 'is-invalid' : ''}`}
                    placeholder="Password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                </div>
                <span
                  className="toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <Icon icon={showPassword ? "solar:eye-closed-outline" : "solar:eye-outline"} />
                </span>
              </div>
              <span className="mt-12 text-sm text-secondary-light d-block">
                Your password must have at least 8 characters
              </span>
            </div>

            <div className="">
              <div className="d-flex justify-content-between gap-2">
                <div className="form-check style-check d-flex align-items-start">
                  <input
                    className="form-check-input border border-neutral-300 mt-4"
                    type="checkbox"
                    id="condition"
                    required
                  />
                  <label className="form-check-label text-sm" htmlFor="condition">
                    By creating an account means you agree to the{" "}
                    <Link to="#" className="text-primary-600 fw-semibold">
                      Terms & Conditions
                    </Link>{" "}
                    and our{" "}
                    <Link to="#" className="text-primary-600 fw-semibold">
                      Privacy Policy
                    </Link>
                  </label>
                </div>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              ) : null}
              Sign Up
            </button>

            <div className="mt-32 center-border-horizontal text-center">
              <span className="bg-base z-1 px-4">Or sign up with</span>
            </div>

    

            <div className="mt-32 text-center text-sm">
              <p className="mb-0">
                Already have an account?{" "}
                <Link to="/" className="text-primary-600 fw-semibold">
                  Sign In
                </Link>
              </p>
            </div>
          </form>
   </>
  );
};

export default SignUpLayer;
